export default "__VITE_ASSET__9c062f87__"